import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface CollaborationUser {
    _id: string;
    displayName: string;
    position: string;
    role: string;
}

const listCollaborationUsers = async (
    sessionId: string,
    orderId: string,
): Promise<CollaborationUser[]> => {
    const { data } = await axios.get(`${API_URL}/order/collaborate/list-users`, {
        params: { orderId },
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useListCollaborationUsers = (orderId: string) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/order/collaborate/list-users', orderId],
        queryFn: () => listCollaborationUsers(sessionContext?.sessionId ?? '', orderId),
        enabled: !!sessionContext?.sessionId && !!orderId,
        staleTime: 3 * 1000,
        refetchInterval: 3 * 1000,
    });
};
